import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag } from 'api-paths-cas';
import { PathwayIndicator } from '../../../atoms/icons/PathwayIndicator';

export const PathwayTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip hasArrow placement="bottom" label={<PathwayHover pathwayUni={tag.pathwayUni!} />}>
      <Tag size="xs" variant="solid" data-selector="tag-pathway" {...tagProps}>
        <Box mr="0.5">
          <PathwayIndicator />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const PathwayHover = ({ pathwayUni }: { pathwayUni: string }) => {
  return (
    <Box>
      Pathway Student
      <br />
      <b>{pathwayUni}</b>
    </Box>
  );
};
